/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { ReactNode } from 'react';
import { Button, DialogContent, DialogActions } from '@mui/material';
import { CANCEL_BTN_TEXT, SAVE } from './constants';
import { useStyles } from './styles';
import Loader from '../Loader';

interface ManageLocationsDialogShellProps {
  isSaveDisabled?: boolean;
  isRequesting?: boolean;
  onSave?: () => void;
  onClose: () => void;
  children: ReactNode;
}

const ManageLocationsDialogShell = ({
  isSaveDisabled = false,
  isRequesting = false,
  onSave,
  onClose,
  children
}: ManageLocationsDialogShellProps) => {
  const { classes } = useStyles();

  return (
    <>
      <DialogContent className={classes.dialogContent}>{children}</DialogContent>
      <DialogActions className={classes.dialogActions}>
        {isRequesting && <Loader showLoader={true} />}
        <Button onClick={onClose} variant="outlined" color="primary">
          {CANCEL_BTN_TEXT}
        </Button>
        <Button onClick={onSave} variant="contained" color="primary" disabled={isSaveDisabled}>
          {SAVE}
        </Button>
      </DialogActions>
    </>
  );
};

export default ManageLocationsDialogShell;
